import { envConfig } from '@root/env';
import { Delete, Get, Post, Put } from '@/service/request/server';
import { getHeader } from '@/utils/storage';

const baseUrl = envConfig.storageServiceUrl + '/cloud-storage/1.1/classes/';
const batchBaseUrl = envConfig.storageServiceUrl + '/cloud-storage/1.1/batch/';

function baseApi() {

    function createClass(data, appId, className) {
        return Post(baseUrl + `${className}`, data, getHeader(appId));
    }

    function queryClassByObjectId(objectId, appId, className) {
        return Get(baseUrl + `${className}/${objectId}`, {}, getHeader(appId));
    }

    function queryClassList(data, appId, className) {
        return Get(baseUrl + `${className}`, data, getHeader(appId));
    }

    function deleteClass(objectId, appId, className) {
        return Delete(baseUrl + `${className}/${objectId}`, getHeader(appId));
    }

    function updateClass(objectId, data, appId, className) {
        return Put(baseUrl + `${className}/${objectId}`, data, getHeader(appId));
    }

    function batch(data, appId) {
        return Post(batchBaseUrl, data, getHeader(appId));
    }

    return {
        createClass, deleteClass, queryClassByObjectId, queryClassList, updateClass, batch
    };
}

export const storageClassApi = baseApi();
